import {
  CUSTOM_ELEMENTS_SCHEMA,
  Component,
  OnInit,
  OnDestroy,
} from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { SharedModule } from './shared/shared.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { LoadingService } from './services/loading.service';
import { NgIf } from '@angular/common';
import { Subscription } from 'rxjs';
import { PrivacyBannerComponent } from './components/privacy-banner/privacy-banner.component';
import { FooterComponent } from './components/footer/footer.component';
import { AuthService } from './services/auth.service';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [
    RouterOutlet,
    SharedModule,
    FormsModule,
    ReactiveFormsModule,
    HttpClientModule,
    MatProgressBarModule,
    NgIf,
    PrivacyBannerComponent,
    FooterComponent
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  template: `
    <app-privacy-banner *ngIf="isAuthenticated"></app-privacy-banner>
    <router-outlet></router-outlet>
    <app-footer *ngIf="isAuthenticated"></app-footer>
  `,
  styleUrl: './app.component.scss',
})
export class AppComponent implements OnInit, OnDestroy {
  title = 'collary-front';
  loading = false;
  subscription: Subscription;
  isAuthenticated = false;

  constructor(
    public loadingService: LoadingService,
    private authService: AuthService
  ) {}

  ngOnInit() {
    this.subscription = this.loadingService.getLoading().subscribe((value) => {
      this.loading = value;
    });

    // Subscribe to user authentication state
    this.authService.getUser().subscribe(user => {
      this.isAuthenticated = !!user;
    });
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }
}
